export const RELAY_TIMEOUT = 30
export const REBOOT_TIMEOUT = 45000
export const CONF_READ_TIMEOUT = REBOOT_TIMEOUT + 5000
export const CHUNK_MAX_ESTIMATE = 1758
export const INSTALLER_PASSWORD = '1234'
export const APPLIANCES_WITHOUT_INSTALLER_LEVEL = ['EV_CHARGER', 'RADIATOR', 'AIR_AIR_HEAT_PUMP', 'AIR_WATER_HEAT_PUMP', 'GROUND_SOURCE_HEAT_PUMP', 'BOILER', 'IN_FLOOR_HEATING', 'STORAGE_TANK', 'HEAT_PUMP']
export const SUPPORTED_LANGUAGES = ['en', 'fi']
export const MOBILE_SIZE = 450
export const PROFIT_BAR_COUNT = 15
export const PROFIT_MONTHLY_FEE = 0 // Was: 34.90
